var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03819 6.0806C8.03819 6.29278 7.9417 6.50493 7.7491 6.6667L1.68577 11.7571C1.30007 12.081 0.674705 12.081 0.289155 11.7571C-0.096385 11.4334 -0.096385 10.9085 0.289155 10.5847L5.65434 6.0806L0.289345 1.57648C-0.096205 1.25267 -0.096205 0.72781 0.289345 0.404148C0.674895 0.0801735 1.30025 0.0801735 1.68596 0.404148L7.7493 5.49452C7.94191 5.65637 8.03819 5.86851 8.03819 6.08061V6.0806Z",
    fill: "#222B45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRight);
export default __webpack_public_path__ + "static/media/ico-right.86a5e5c5aa801e89e5f4db5e8610f3f9.svg";
export { ForwardRef as ReactComponent };